import { render } from "./AuthTemplate.vue?vue&type=template&id=0476c1a8"
const script = {}

import "./AuthTemplate.vue?vue&type=style&index=0&id=0476c1a8&lang=css"

import exportComponent from "/home/runner/work/onino-app/onino-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__